import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Collapse } from '@material-ui/core';

import { ChevronIcon } from 'src/components/ChevronIcon';
import { SidebarButton } from '../SidebarButton';
import { SidebarSubmenuItem } from '../SidebarSubmenuItem';
import { useStyles } from './useStyles';

export const SidebarSubmenu = ({ className, item, expanded, onToggle, activePath }) => {
  const styles = useStyles();

  const handleButtonClick = useCallback(() => {
    onToggle(item);
  }, [onToggle, item]);

  return (
    <div className={cx(styles.root, className, { [styles.expanded]: expanded })}>
      <SidebarButton
        className={styles.button}
        item={item}
        onClick={handleButtonClick}
        endIcon={
          <ChevronIcon
            className={styles.iconExpand}
            direction={expanded ? 'down' : 'right'}
          />
        }
      />

      <Collapse
        className={styles.collapse}
        in={expanded}
      >
        <div className={styles.items}>
          {item.items?.map((menuItem) => {
            if (menuItem.disabled) {
              return null;
            }

            return (
              <SidebarSubmenuItem
                className={styles.item}
                key={menuItem.path}
                item={menuItem}
                active={activePath.startsWith(menuItem.path)}
              />
            );
          })}
        </div>
      </Collapse>
    </div>
  );
};

SidebarSubmenu.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({}).isRequired,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  activePath: PropTypes.string,
};

SidebarSubmenu.defaultProps = {
  className: '',
  expanded: false,
  activePath: '',
};
